import { MelwaysProvider } from '@seek/melways-react';
import type { SiteName } from '@seek/melways-sites';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router';

export const MelwaysClientProvider = ({
  children,
  siteName,
  environment,
}: {
  children: ReactNode;
  siteName: SiteName;
  environment: string;
}) => {
  const { pathname } = useLocation();
  return (
    <MelwaysProvider.Client
      path={pathname}
      site={siteName}
      staging={environment === 'staging'}
    >
      {children}
    </MelwaysProvider.Client>
  );
};
